import { apiRequest } from '@utils/request';

export const sendContactRequest = async (
	firstName: string,
	lastName: string,
	email: string,
	message: string,
	mixpanelId: string,
	clientId: string,
	isAdvisor = false
): Promise<void> => {
	await apiRequest.post(`/contact`, {
		firstName,
		lastName,
		email,
		message,
		mixpanelId,
		clientId,
		isAdvisor
	});
};

export const sendConnectApiContactRequest = async (
	firstName: string,
	lastName: string,
	email: string,
	message: string,
	mixpanelId: string,
	clientId: string,
	isAdvisor = false
): Promise<void> => {
	await apiRequest.post(`/fundrise-connect/contact`, {
		firstName,
		lastName,
		email,
		message,
		mixpanelId,
		clientId,
		isAdvisor
	});
};
